/* YF-CC v86 (Claude, Oct 2026): on-page Cowlendar booking. Notes: snippets/yf-cc-notes.liquid */
(function () {
  function $(s, r) { return (r || document).querySelector(s); }
  function after(ref, el) { ref.parentNode.insertBefore(el, ref.nextSibling); }
  /*
     Every booking link to app.cowlendar.com/cal/<service>/<variant> opens Cowlendar's own booking window in a panel
     on this page instead of leaving the site. The weight and terms gate (snippets/yfla-consent-gate.liquid) still runs
     first: it stops the first click in the capture phase and re-clicks the link once consent is recorded, and only
     that second click reaches this handler. The panel carries data-yfla-nogate so the gate leaves clicks inside it
     alone. After a paid booking Cowlendar's app.js adds the flight to this cart and opens checkout, as on the
     product pages. The consultation page shows the same window inline, with no click needed. */
  var SHOP = (window._cowlendarConfig && window._cowlendarConfig.shop_url) || (window.Shopify && window.Shopify.shop) || '';
  var CONSULT = { sid: '6a9dcb8fc808f2b0303476c8', vid: '44162185199690' };
  function calSrc(c) { return 'https://widget.cowlendar.com/booking/embed?shop=' + encodeURIComponent(SHOP) + '&sid=' + c.sid + '&qty=1&mode=inline&locale=en' + (c.vid ? '&vid=' + c.vid : ''); }
  function parseCal(href) { var m = String(href || '').match(/cowlendar\.com\/cal\/([a-z0-9]+)(?:\/(\d+))?/i); return m ? { sid: m[1], vid: m[2] || '' } : null; }
  var COW_CSS = 'html.yfcc-lock{overflow:hidden}' +
    '#yfcc-cow{position:fixed;inset:0;z-index:2147482000;display:none;align-items:center;justify-content:center;padding:max(12px,env(safe-area-inset-top,0px)) max(12px,env(safe-area-inset-right,0px)) max(12px,env(safe-area-inset-bottom,0px)) max(12px,env(safe-area-inset-left,0px));background:rgba(11,18,32,.72);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px)}' +
    '#yfcc-cow.on{display:flex}' +
    '#yfcc-cow .pn{width:100%;max-width:560px;height:min(860px,92vh);background:#fff;border-radius:20px;display:flex;flex-direction:column;overflow:hidden;box-shadow:0 30px 90px rgba(0,0,0,.45)}' +
    '#yfcc-cow .hd{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:14px 18px;border-bottom:1px solid #e3e5ea}' +
    '#yfcc-cow h2{font:700 18px/1.25 Inter,sans-serif;margin:0;color:#16171a;letter-spacing:-.01em;text-transform:none}' +
    '#yfcc-cow .x{width:40px;height:40px;border-radius:50%;border:1px solid #e3e5ea;background:#fff;color:#16171a;font-size:18px;cursor:pointer;flex:none;padding:0}' +
    '#yfcc-cow iframe{flex:1;width:100%;border:0;display:block}' +
    '#yfcc-cow .ft{margin:0;padding:10px 18px 14px;font:500 13px/1.4 Inter,sans-serif;color:#5b6170;border-top:1px solid #e3e5ea}' +
    '#yfcc-cow .ft a{color:#16171a;font-weight:700}' +
    '@media (max-width:600px){#yfcc-cow{padding:0;align-items:flex-end}#yfcc-cow .pn{max-width:none;height:94vh;border-radius:20px 20px 0 0}}' +
    '.yfcc-cowin{border:1px solid #e3e5ea;border-radius:16px;overflow:hidden;background:#fff}' +
    '.yfcc-cowin iframe{display:block;width:100%;height:640px;border:0}' +
    '@media (max-width:600px){.yfcc-cowin iframe{height:600px}}' +
    '.yfcc-con .hero:before{background:linear-gradient(180deg,rgba(8,7,10,.55),rgba(8,7,10,.9))!important}';
  function cowStyle() { if ($('#yfcc-cow-css')) return; var s = document.createElement('style'); s.id = 'yfcc-cow-css'; s.textContent = COW_CSS; document.head.appendChild(s); }
  var sheet = null, lastFocus = null;
  function closeSheet() {
    if (!sheet) return;
    sheet.classList.remove('on'); document.documentElement.classList.remove('yfcc-lock');
    $('iframe', sheet).src = 'about:blank';
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function openSheet(c, title) {
    cowStyle();
    if (!sheet) {
      sheet = document.createElement('div');
      sheet.id = 'yfcc-cow';
      sheet.setAttribute('data-yfla-nogate', '');
      sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); sheet.setAttribute('aria-labelledby', 'yfcc-cow-h');
      sheet.innerHTML = '<div class="pn"><div class="hd"><h2 id="yfcc-cow-h"></h2><button type="button" class="x" aria-label="Close">✕</button></div><iframe title="Pick a day and time"></iframe><p class="ft">Questions first? Call or text <a href="tel:+18183301318">(818) 330-1318</a>, 9 AM–9 PM, seven days.</p></div>';
      document.body.appendChild(sheet);
      sheet.addEventListener('click', function (e) { if (e.target === sheet || e.target.closest('.x')) closeSheet(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.classList.contains('on')) closeSheet(); });
    }
    lastFocus = document.activeElement;
    $('h2', sheet).textContent = title;
    $('iframe', sheet).src = calSrc(c);
    sheet.classList.add('on'); document.documentElement.classList.add('yfcc-lock');
    setTimeout(function () { try { $('.x', sheet).focus(); } catch (e) {} }, 60);
  }
  function cowTitle(c) {
    var s = (window.cowServices || []).filter(function (x) { return x.service_id === c.sid; })[0];
    if (!s || !s.product_handle) return 'Pick A Day And Time';
    return s.product_handle.replace(/-los-angeles$/, '').replace(/-/g, ' ').replace(/\b\w/g, function (m) { return m.toUpperCase(); });
  }
  function booking() {
    if (!SHOP) return;
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest ? e.target.closest('a[href*="cowlendar.com/cal/"]') : null;
      if (!a || a.closest('#yfcc-cow')) return;
      var c = parseCal(a.getAttribute('href')); if (!c) return;
      e.preventDefault();
      openSheet(c, cowTitle(c));
    });
  }

  function consultInline() {
    var bk = $('#yfcc-consult #book'); if (!bk || !SHOP) return;
    cowStyle();
    if ($('.yfcc-cowin', bk)) return;  // the section already renders the calendar (v86b)
    ['#days', '#slots', '#step2', '#okmsg'].forEach(function (s) { var x = $(s, bk); if (x) x.parentNode.removeChild(x); });
    var box = document.createElement('div');
    box.className = 'yfcc-cowin'; box.setAttribute('data-yfla-nogate', '');
    box.innerHTML = '<iframe title="Pick a day and time for your free consultation" src="' + calSrc(CONSULT) + '"></iframe>';
    var tr = $('.tagrow', bk); if (tr) after(tr, box); else bk.appendChild(box);
    var n = $('#yfcc-calnote', bk); if (n) n.textContent = 'Pacific time. Free, about 30 minutes. Your confirmation comes by email.';
  }

  function run() {
    try { booking(); } catch (e) { console.warn('yfcc booking', e); }
    try { consultInline(); } catch (e) { console.warn('yfcc consult', e); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
